import { createSelector } from "@reduxjs/toolkit";

import { CountryCode } from "@/custom-types/CountryCode";
import { AppState } from "@/redux/store";

const getConfigState = (state: AppState) => state.config;

export const getDomainCountryCode = createSelector(
  [getConfigState],
  (state) => state.domainCountryCode as CountryCode,
);
